var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#8B8D8E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Azienda",
    transform: "translate(536 -5089)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_124",
    x: -536,
    y: 5089,
    className: "st0",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-508.7,5120.7c1-0.9,1.7-2.2,1.7-3.7c0-2.8-2.2-5-5-5s-5,2.2-5,5c0,1.5,0.7,2.8,1.7,3.7 c-2.6,1.3-4.4,3.9-4.5,7v1.1c0,0.6,0.4,1,1,1h13.6c0.6,0,1-0.4,1-1v-1.1C-504.3,5124.6-506.1,5122-508.7,5120.7z M-515,5117 c0-1.7,1.3-3,3-3s3,1.3,3,3c0,1.5-1.1,2.7-2.5,2.9c-0.2,0-0.4,0-0.5,0c0,0,0,0,0,0c-0.2,0-0.4,0-0.5,0 C-514,5119.7-515,5118.5-515,5117z M-506.3,5127.8h-11.6v-0.1c0-3,2.3-5.5,5.2-5.8c0.2,0,0.4,0.1,0.5,0.1s0.4,0,0.5-0.1 c2.9,0.3,5.2,2.8,5.2,5.8V5127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-497.5,5103.8c0.9-0.8,1.5-2,1.5-3.3c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5c0,1.3,0.5,2.4,1.3,3.2 c-2.2,1.2-3.7,3.8-3.7,7c0,0.6,0.4,1,1,1h11.3c0.6,0,1-0.4,1-1C-494.1,5107.6-495.4,5105.1-497.5,5103.8z M-503,5100.5 c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5c0,1.3-1,2.4-2.3,2.5c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0 C-502.1,5102.8-503,5101.8-503,5100.5z M-505.3,5109.7c0.3-2.8,2.1-4.7,4.5-4.8c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0 c2.3,0.2,4,2,4.3,4.8H-505.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-516.7,5110.7c0-3.3-1.4-5.9-3.7-7.1c0.8-0.8,1.3-1.9,1.3-3.2c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5 c0,1.3,0.6,2.5,1.5,3.3c-2.1,1.3-3.5,3.8-3.5,6.9c0,0.6,0.4,1,1,1h11.3C-517.1,5111.7-516.7,5111.3-516.7,5110.7z M-526,5100.5 c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5c0,1.3-0.9,2.3-2.1,2.5c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0 C-525,5102.9-526,5101.8-526,5100.5z M-527.9,5109.7c0.3-2.7,2-4.6,4.3-4.8c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0 c2.4,0.1,4.1,1.9,4.5,4.8H-527.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-516.6,5103.8h9c0.6,0,1-0.4,1-1s-0.4-1-1-1h-9c-0.6,0-1,0.4-1,1S-517.1,5103.8-516.6,5103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-518.8,5119.6c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-4.5-4.5c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4 l4.5,4.5C-519.3,5119.5-519.1,5119.6-518.8,5119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-501.4,5113.4l-4.5,4.5c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l4.5-4.5 c0.4-0.4,0.4-1,0-1.4S-501.1,5113-501.4,5113.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.d005937822d2d4cc78b115811009fcaf.svg";
export { ForwardRef as ReactComponent };